import styled from 'astroturf/react'
import { useSelector } from 'react-redux'

import Details from 'components/details'
import EventTime from 'components/details/event_time'
import Timezone from 'components/details/timezone'
import { currentInviteeSelector } from 'selectors/current_invitee'
import { isPublisherSelector, timeNotationSelector } from 'selectors'
import { nameSelector } from 'selectors/invitee'
import { useI18n } from 'locales'
import _Container from "details-Container.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/rescheduling/details.js?styleId=Container";
import _Title from "details-Title.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/rescheduling/details.js?styleId=Title";


const Container = /*#__PURE__*/styled('div', null, {
  displayName: "Container",
  styles: _Container
})
const Title = /*#__PURE__*/styled('div', null, {
  displayName: "Title",
  styles: _Title
})

const FormerDetails = ({ crossedItems, ...restProps }) => {
  const { i18n } = useI18n()
  const isPublisher = useSelector(isPublisherSelector)
  const invitee = useSelector(currentInviteeSelector)
  const inviteeName = useSelector(nameSelector)
  const timeNotation = useSelector(timeNotationSelector)

  if (!invitee) return null

  return (
    <Container {...restProps}>
      <Details crossedItems={crossedItems}>
        <Title>
          {i18n.t('booking.templates.former_time')}
          {isPublisher && (
            ` (${inviteeName})`
          )}
        </Title>
        <EventTime
          source={invitee.event}
          timezone={invitee.timezone}
          timeNotation={timeNotation}
        />
        <Timezone value={invitee.timezone} />
      </Details>
    </Container>
  )
}

export default FormerDetails
